export default function FooterContact() {
  return (
    <footer className="relative bg-accent-900 text-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div>
            <p className="text-sm text-accent-200 leading-relaxed font-body max-w-xs">
              A professional engineering team focused on designing and developing modern digital
              software solutions for the iOS platform and related technologies.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-5 font-label">
              Contact
            </h4>
            <div className="space-y-3 text-sm text-background-100 font-body leading-relaxed">
              <p>Taikos pr. 111-74</p>
              <p>Klaipeda, 94230</p>
              <p>Lithuania</p>
              <p className="pt-2">+370 66806273</p>
              <p>ceo@advnetdigital.com</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-5 font-label">
              Practices
            </h4>
            <div className="space-y-3 text-sm text-background-100 font-body">
              <p className="leading-relaxed">Clean Architecture</p>
              <p className="leading-relaxed">Performance Optimization</p>
              <p className="leading-relaxed">User-Centered Design</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-5 font-label">
              Values
            </h4>
            <div className="space-y-3 text-sm text-background-100 font-body">
              <p className="leading-relaxed">Continuous Innovation</p>
              <p className="leading-relaxed">Stability</p>
              <p className="leading-relaxed">Long-Term Quality</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative flex items-center justify-center py-16 md:py-24 bg-accent-950/50">
        <span
          className="text-[120px] md:text-[180px] font-bold text-accent-800/30 select-none font-heading leading-none tracking-tighter"
          aria-hidden="true"
        >
          A
        </span>
      </div>

      <div className="border-t border-accent-800/40">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-accent-400 font-body">
            &copy; {new Date().getFullYear()} ADVNET DIGITAL, UAB. All rights reserved.
          </p>
          <p className="text-xs text-accent-500 font-body">
            Engineering excellence for the iOS platform
          </p>
        </div>
      </div>
    </footer>
  );
}